import './Shipments.css';
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Shipments(){
    const [resText, setResText] = useState("Fetching...");
    const [shipments, setShipments] = useState(JSON.parse(localStorage.getItem("shipments")));


    useEffect(()=>{ 
        fetch("http://localhost:80/api/v2/shipments/getShipments.php", {mode: 'cors'})
        .then(response => response.json())
        .then(data => {
            setShipments(data)
            localStorage.setItem("shipments", JSON.stringify(shipments))
        })
    }, [])
    return(
        <>
            <div>Search</div>
            <div>Table</div>
            <div>{shipments}</div>
        </>
    )
}